'use strict';

angular.module('app.common')

.directive('gaEventClick', [ 'GaService', 'DataService', function(gaService, dataService) {
	return {
		restrict: 'A',
		link: function(scope, element, attrs) {
			element.bind('click', function($event) {
				var location = dataService.getCurrentLocation().locationCode;
				gaService.gaTrackClickFromLinks(location + ' : ' + attrs['pagename'], attrs['linkname'], $event.currentTarget.hash);
			});
		}
	}
} ]);



// WEBPACK FOOTER //
// ./app/common/directives/ga/gaEventClickDirective.js